export const servers = {
  real:'ws://78.188.151.83:13890' //server-aysenur
};
